// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useMemo } from 'react'
import { SecondaryButton } from 'ui_kit_qmd'
import { styles, text } from './Constants'
import './ViewAllCards.scss'
import 'react-calendar/dist/Calendar.css'
import plusIcon from '../../../../../../../../images/common/plusIcon.png'
import closeIcon from '../../../../../../../../images/common/close.png'
import { Card } from '../card/Card'
import SimpleBar from 'simplebar-react'
import 'simplebar-react/dist/simplebar.min.css'
import errorIcon from '../../../../../../../../images/common/error-icon.svg'
import infoIcon from '../../../../../../../../images/common/info-icon.svg'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const ViewAllCards = ({ addPaymentClick, cards, selectCard, viewAllCards }) => {
  const isMaxCards = useMemo(() => cards.length === 10, [cards.length])

  const bannerIcon = isMaxCards ? errorIcon : infoIcon
  const bannerText = isMaxCards ? text.ERROR : text.INFO

  return (
    <div className='review-book-visit-payment-methods-view-all-card-pop-up-container'>
      <div className='review-book-visit-payment-methods-view-all-cards-container'>
        <div className='review-book-visit-payment-methods-view-all-cards-header'>
          <label htmlFor='null' className='review-book-visit-payment-methods-view-all-cards-title'>
            {text.PAYMENT_METHODS}
          </label>

          <div className='review-book-visit-payment-methods-view-all-cards-right-header'>
            <SecondaryButton
              btnText={text.NEW}
              onPress={addPaymentClick}
              containerStyle={styles.BUTTON_CONTAINER_STYLE}
              image={plusIcon}
              imageStyle={styles.BUTTON_IMAGE_STYLE}
              disabled={isMaxCards}
            />
            <img
              role='presentation'
              src={closeIcon}
              alt={text.CLOSE_ADD_CARD}
              className='review-book-visit-payment-methods-view-all-cards-close-icon'
              onClick={() => viewAllCards(false)}
            />
          </div>
        </div>
        <div className={`review-book-visit-payment-methods-banner ${isMaxCards ? 'max-cards-reached' : ''}`}>
          <img
            src={bannerIcon}
            alt={isMaxCards ? 'Error Icon' : 'Info Icon'}
            className='review-book-visit-payment-methods-banner-icon'
          />
          <span className='review-book-visit-payment-methods-banner-text'>{bannerText}</span>
        </div>

        {cards?.length ?
          <SimpleBar
            className='review-book-visit-payment-methods-view-all-cards-list-container'
            style={{ maxHeight: 328 }}
            autoHide>
            {/*
             // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered */}
            {cards.map((card) => (
              // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
              <Card key={card.Id} card={card} selectCard={selectCard} />
            ))}
          </SimpleBar>
        : null}
      </div>
    </div>
  )
}
